"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _EditorContext = require("../../EditorContext");

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SideBarIconButton = function SideBarIconButton(_ref) {
  var entityType = _ref.entityType,
      icon = _ref.icon,
      name = _ref.name;

  var _useContext = (0, _react.useContext)(_EditorContext.EditorContext),
      showPluginEditor = _useContext.showPluginEditor;

  var onClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    showPluginEditor(entityType, true);
  }, [entityType, showPluginEditor]);
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-center card shadow border-0 p-4 m-2",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark d-flex flex-column icon-button-holder mx-auto"
  }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
    className: "mx-auto my-auto",
    icon: icon,
    size: "1_3x"
  }), /*#__PURE__*/_react["default"].createElement("small", {
    className: "mt-2"
  }, name)));
};

var _default = SideBarIconButton;
exports["default"] = _default;
module.exports = exports.default;